function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "\u5F62\u72B6");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "\\u5DE5\\u4F5C\\u53F0/\\u89D2\\u8272\\u7BA1\\u7406/\\u5B50\\u8D26\\u53F7",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "\\u4E3B\\u8D26\\u53F7-\\u5DE5\\u4F5C\\u53F0",
  transform: "translate(-939.000000, -17.000000)",
  fill: "#666666",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "\\u7F16\\u7EC4-67",
  transform: "translate(939.000000, 17.000000)"
}, React.createElement("path", {
  d: "M9.93938113,8.93352149 C12.3369616,10.0306562 14,12.4284523 14,15.2098765 C14,15.6462497 13.6418278,16 13.2,16 C12.7581722,16 12.4,15.6462497 12.4,15.2098765 C12.4,12.2643579 9.98233765,9.87654321 7,9.87654321 C4.01766235,9.87654321 1.6,12.2643579 1.6,15.2098765 C1.6,15.6462497 1.2418278,16 0.8,16 C0.3581722,16 0,15.6462497 0,15.2098765 C0,12.4284523 1.6630384,10.0306562 4.06061887,8.93352149 C2.81175761,8.03571273 2,6.5806199 2,4.9382716 C2,2.21093951 4.23857625,0 7,0 C9.76142375,0 12,2.21093951 12,4.9382716 C12,6.5806199 11.1882424,8.03571273 9.93938113,8.93352149 L9.93938113,8.93352149 Z M7,8.2962963 C8.87776815,8.2962963 10.4,6.79285743 10.4,4.9382716 C10.4,3.08368578 8.87776815,1.58024691 7,1.58024691 C5.12223185,1.58024691 3.6,3.08368578 3.6,4.9382716 C3.6,6.79285743 5.12223185,8.2962963 7,8.2962963 Z",
  id: "\\u5F62\\u72B6"
}))));

var SvgBypassAccount = function SvgBypassAccount(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "14px",
    height: "16px",
    viewBox: "0 0 14 16",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBypassAccount, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bypassAccount.0814c516.svg";
export { ForwardRef as ReactComponent };